import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Chromosome extends Vue {
    deleties = [
        'p25',
        'p24',
        'p23',
        'p22',
        'p21',
        'p12',
        'p11',
        false,
        'q11',
        'q12',
        'q13',
        'q14',
        'q15',
        'q16',
        'q21',
        'q22',
        'q23',
        'q24',
        'q25',
        'q26',
        'q27',
    ];

    isEven(n: number) {
        return n % 2 === 0;
    }

    buttonClass(filter: string, n: number) {
        return [
            this.isEven(n) ? 'is-even' : 'is-odd',
            filter ? '' : 'is-centromeer',
            this.$store.getters.has_filter(filter) ? 'active' : '',
        ];
    }

    get showAllClass() {
        return !this.$store.getters.filter && this.$store.state.deldup.del && this.$store.state.deldup.dup ?
            'is-success' : 'is-inactive';
    }

    get delClass() {
        if (this.$store.state.deldup.del && !this.$store.state.deldup.dup) {
            return 'is-success';
        } else {
            return 'is-inactive';
        }
    }

    get dupClass() {
        if (this.$store.state.deldup.dup && !this.$store.state.deldup.del) {
            return 'is-success';
        } else {
            return 'is-inactive';
        }
    }

    click(filter: string) {
        if (filter) {
            if (this.$store.getters.has_filter(filter)) {
                this.$store.commit('remove_filter', filter);
            } else {
                this.$store.commit('add_filter', filter);
            }
        }
    }
}
